import { Box, HStack } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { useCreditFacilityOrThrow } from '~/contexts/CreditFacilitiesProvider';
import { PortfolioTemplate } from '~/packages/portfolio/ui/shared/PortfolioTemplate';
import { useTransactionsFilters } from '~/packages/transactions/hooks/transactionsHooks';
import { TransactionsChartSummary } from '~/packages/transactions/ui/TransactionsChartSummary';
import { TransactionsFiltersDrawer } from '~/packages/transactions/ui/TransactionsFiltersDrawer';
import { TransactionsStatementsDrawer } from '~/packages/transactions/ui/TransactionsStatementsDrawer';
import { TransactionsView } from '~/packages/transactions/ui/TransactionsView';

export const PortfolioTransactionsContent = ({
  creditFacilityId,
}: {
  creditFacilityId: string;
}) => {
  const creditFacility = useCreditFacilityOrThrow(creditFacilityId);
  const [transactionsFilters, setTransactionsFilters] = useTransactionsFilters({
    creditFacilityIds: creditFacility ? [creditFacility.id] : [],
  });

  if (!creditFacility) {
    return <Navigate to="/portfolio/overview/facilities" replace />;
  }

  return (
    <PortfolioTemplate
      creditFacilityId={creditFacility.id}
      creditFacilityName={creditFacility.name}
      selectedTab="transactions"
    >
      <Box display="flex" flexDirection="column" gap="1.5rem">
        <HStack justify="flex-end" mb="1rem">
          <HStack gap="1.5rem">
            <TransactionsStatementsDrawer
              {...transactionsFilters}
              lockedCreditFacilityId={creditFacility.id}
            />
            <TransactionsFiltersDrawer
              {...transactionsFilters}
              onFilterChange={setTransactionsFilters}
              filtersToDisable={{ creditFacilityIds: true }}
            />
          </HStack>
        </HStack>
        <TransactionsChartSummary {...transactionsFilters} />
        <TransactionsView filterDerivedState={transactionsFilters} />
      </Box>
    </PortfolioTemplate>
  );
};
